import * as React from 'react';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers';

import { ThemeProvider, InputAdornment } from "@mui/material";
import dayjs, {Dayjs} from "dayjs";

import {FC} from "react";
import {newTheme} from "../../../pages/landing/SignUp2_Talent/components/components.utils";

interface MaterialCalendarPickerProps {
    format?: string;
    label: string;
    defaultValue?: Dayjs | null;
    value?: Dayjs | null;
    onChange?: (date: Dayjs | null) => void;
    error?: string;
    views?: ('day' | 'month' | 'year')[];
    name: string;
    disabled?: boolean;
    className?: string;
    /** Optional icon to be shown at the beginning of the text field */
    startAdornmentIcon?: React.ReactNode;
}

const MaterialCalendarPicker: FC<MaterialCalendarPickerProps> = (
    {
        format = 'LL',
        label,
        defaultValue,
        value,
        onChange,
        error,
        views,
        disabled,
        className,
        startAdornmentIcon,
    }: MaterialCalendarPickerProps) => {
    const [open, setOpen] = React.useState(false);

    const formatedViews = views?.filter((value, index, array) => array.indexOf(value) === index);

    return (
        <ThemeProvider theme={newTheme}>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                    className={className}
                    format={format}
                    disabled={disabled}
                    label={label}
                    defaultValue={defaultValue ? dayjs(defaultValue) : null}
                    value={value ? dayjs(value) : null}
                    onChange={onChange}
                    open={open}
                    onOpen={() => setOpen(true)}
                    onClose={() => setOpen(false)}
                    sx={{ width: '100%' }}
                    slotProps={{
                        day: {
                            sx: {
                                /** T2-5766: align selected day with TempStars cobalt blue brand colour */
                                "&.MuiPickersDay-root.Mui-selected": {
                                    backgroundColor: '#0B4598',
                                },
                                "&.MuiPickersDay-root.Mui-selected:hover, &.MuiPickersDay-root.Mui-selected:focus": {
                                    backgroundColor: '#093776',
                                },
                            },
                        },
                        textField: {
                            fullWidth: true,
                            className: 'fakeDisabled',
                            error: !!error,
                            helperText: error,
                            color: error ? 'warning' : undefined,
                            sx: {
                                cursor: 'pointer',
                                '& .MuiInputBase-root': {
                                    cursor: 'pointer',
                                },
                                '& .MuiInputBase-input': {
                                    cursor: 'pointer',
                                },
                                '& .Mui-disabled': {
                                    color: error ? 'rgb(211, 47, 47) !important' : undefined,
                                    cursor: 'pointer !important',
                                    WebkitTextFillColor: error ? 'rgb(211, 47, 47) !important' : undefined,
                                },
                            },
                            InputProps: {
                                readOnly: true,
                                onClick: () => setOpen(true),
                                sx: { cursor: 'pointer' },
                                startAdornment: startAdornmentIcon ? (
                                    <InputAdornment position="start" sx={{ pl: 1, pr: 1 }}>
                                        {startAdornmentIcon}
                                    </InputAdornment>
                                ) : undefined,
                                endAdornment: null, // Remove the default right calendar icon
                            },
                        },
                        // Hide the default open picker button (right calendar icon)
                        openPickerButton: {
                            sx: { display: 'none' },
                        },
                    }}
                    views={formatedViews?.length ? [...formatedViews] : undefined}
                />
            </LocalizationProvider>
        </ThemeProvider>
    );
}

export default MaterialCalendarPicker;
